import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';
import Login from '../pages/authentication/Login';
const AuthGuard = ({ children }) => {
    const { isAuthenticated } = useAuth();
    const location = useLocation();
    const [requestedLocation, setRequestedLocation] = useState(null);
    if (!isAuthenticated) {
        if (location.pathname !== requestedLocation) {
            setRequestedLocation(location.pathname);
        }
        return _jsx(Login, {});
    }
    // This is done so that in case the route changes by any chance through other
    // means between the moment of request and the render we navigate to the initially
    // requested route.
    if (requestedLocation && location.pathname !== requestedLocation) {
        setRequestedLocation(null);
        return _jsx(Navigate, { to: requestedLocation });
    }
    return _jsx(_Fragment, { children: children });
};
AuthGuard.propTypes = {
    children: PropTypes.node,
};
export default AuthGuard;
//# sourceMappingURL=AuthGuard.js.map